import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailPrescripteurComponent } from './detail-prescripteur/detail-prescripteur.component';
import { PrescripteurFormComponent } from './prescripteur-form/prescripteur-form.component';
import { ListPrescripteurComponent } from './list-prescripteur/list-prescripteur.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { PrescripteurModalAjoutFormComponent } from './modal/prescripteur-modal-ajout-form/prescripteur-modal-ajout-form.component';

@NgModule({
	declarations: [
		DetailPrescripteurComponent,
		PrescripteurFormComponent,
		ListPrescripteurComponent,
		PrescripteurModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class PrescripteursModule {}
